export default function PHP_is_finite() {
  return (
    <div>
      <h1>PHP_is_finite</h1>
    </div>
  );
}
